import React, { useState, useEffect } from 'react';
import { any, node, number, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';

import { AspectRatioWrapper } from '../../components';

import css from './ImageFromFile.module.css';

// readImage returns a promise which is resolved
// when FileReader has loaded given file as dataURL
const readImage = file =>
  new Promise((resolve, reject) => {
    if (!window?.FileReader) {
      reject(new Error(`No FileReader found from window scope.`));
      return;
    }
    const reader = new FileReader();
    reader.onload = e => resolve(e.target.result);
    reader.onerror = e => {
      // eslint-disable-next-line
      console.error('Error (', e, `) happened while reading ${file.name}: ${e.target.result}`);
      reject(new Error(`Error reading ${file.name}: ${e.target.result}`));
    };
    reader.readAsDataURL(file);
  });

// Create elements out of given thumbnail file
const ImageFromFile = props => {
  const {
    className,
    rootClassName,
    imageClassName,
    aspectWidth,
    aspectHeight,
    file,
    id,
    children,
  } = props;
  const [dataURL, setDataURL] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setError(null);
    readImage(file)
      .then(result => {
        if (!cancelled) setDataURL(result);
      })
      .catch(err => {
        if (!cancelled) setError(err);
      });
    return () => { cancelled = true; };
  }, [file]);

  const classes = classNames(rootClassName || css.root, className);

  if (error) {
    return (
      <div className={classes}>
        <FormattedMessage id="ImageFromFile.couldNotReadFile" />
      </div>
    );
  }

  return (
    <div className={classes}>
      <AspectRatioWrapper width={aspectWidth} height={aspectHeight}>
        {dataURL ? (
          <img
            src={dataURL}
            alt={file.name}
            className={imageClassName || css.rootForImage}
          />
        ) : null}
      </AspectRatioWrapper>
      {children}
    </div>
  );
};

ImageFromFile.defaultProps = {
  className: null,
  children: null,
  rootClassName: null,
  imageClassName: null,
  aspectWidth: 1,
  aspectHeight: 1,
};

ImageFromFile.propTypes = {
  className: string,
  rootClassName: string,
  imageClassName: string,
  aspectWidth: number,
  aspectHeight: number,
  file: any.isRequired,
  id: string.isRequired,
  children: node,
};

export default ImageFromFile;
